<template>
  <span class="def-price">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'DefPrice',
};
</script>

<style lang="scss">
.def-price {
  color: #363636;
  font-weight: 500;
  font-size: 18px;
}
</style>
